'use strict';

import React from 'react';

import FaFacebook from 'react-icons/lib/fa/facebook';
import FaLinkedIn from 'react-icons/lib/fa/linkedin';
import FaExternalLink from 'react-icons/lib/fa/external-link';
import FaEnvelope from 'react-icons/lib/fa/envelope';
// import FaFacebook from 'react-icons/lib/fa/facebook';


require('styles//ClientsPage.css');

// function CompanySolution(props) {
//   const solutions = props.solutions;
//   const printSolutions = solutions.map((solution) =>
//     <li key={solution}>{ solution }</li>
//   );
//   return (
//     <div>
//       <p>Soluções Implementadas:</p>
//       <ul>
//         { printSolutions }
//       </ul>
//     </div>
//   );
// }

// function CompanyText(props) {
//   const text = props.text;
//   const printParagraphs = text.map((paragraph) =>
//     <p key={paragraph}>{ paragraph }</p>
//   );
//   return (
//     <div>{ printParagraphs }</div>
//   );
// }

function CompanyLinks(props) {
  const links = props.links;
  const printLinks = links.map((link) => {
    if (link.type == 'EMAIL') {
      return (
        <span className="link" key={link.url}>
          <a href={ 'mailto:' + link.url }><FaEnvelope /></a>
        </span>
      )
    } else if (link.type == 'URL') {
      return (
        <span className="link" key={link.url}>
          <a href={ link.url }><FaExternalLink /></a>
        </span>
      )
    } else if (link.type == 'FACEBOOK') {
      return (
        <span className="link" key={link.url}>
          <a href={ 'https://facebook.com/' + link.url }>
            <FaFacebook/>
          </a>
        </span>
      )
    } else if (link.type == 'LINKEDIN') {
      return (
        <span className="link" key={link.url}>
          <a href={ 'https://linkedin.com/companies/' + link.url }>
            <FaLinkedIn/>
          </a>
        </span>
      )
    }
  }
  );
  return (
    <div className="links">{ printLinks }</div>
  );
}

function CompanyList(props) {
  const area = props.area;
  const printClients = area.clients.map((client) => {
    // let companyImage = require(client.image)
    client.image = client.image.replace('/api/v1/clients/areas', '');
    return (
      <div className="client" key={client.image}>
        <img className="client-logo" src={client.image} alt={client.name}/>
        <div className="client-info">
          {/*<CompanyText text={client.text} />
          <CompanySolution solutions={client.solutions} />*/}
          <CompanyLinks links={client.links} />
        </div>
      </div>
    )
  }
  );
  return (
    <section>
      <h1 className="section-title">{ area.title }</h1>
      <div className="client-list">
        { printClients }
      </div>
    </section>
  );
}


class ClientsPageComponent extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      clientsArray: []
    }
  }

  componentDidMount() {
    return fetch('/api/v1/clients/areas/')
      .then((response) => response.json())
      .then((responseJson) => {
        this.setState({
          clientsArray: responseJson
        })
      })
      .catch(() => {

      });
  }


  render() {
    const listAreas = this.state.clientsArray.map((area) =>
      <CompanyList key={area.title} area={area} />
    );

    return (
      <div className="clientspage-component">
        <div className="header">
          <h2 className="page-title">Clientes</h2>
          <div className="page-description">
            <p>
              A Labor Team trabalha com clientes de diversas áreas de atuação, tais como: comércio a retalho, gabinetes de contabilidade, indústrias de transporte, construção e arquitetura, entre outros.
            </p>
            <p>
              Para cada cliente é fornecida uma solução que vai ao encontro das necessidades do negócio, facilitando assim os processos de faturação, controle de stocks, etc.
            </p>
          </div>
        </div>
        { listAreas }
      </div>
    );
  }
}

ClientsPageComponent.displayName = 'ClientsPageComponent';

// Uncomment properties you need
// ClientsPageComponent.propTypes = {};
// ClientsPageComponent.defaultProps = {};

export default ClientsPageComponent;



// WEBPACK FOOTER //
// ./src/components/ClientsPageComponent.js